//Effects
import { all, put, takeLatest } from 'redux-saga/effects';
import {
  GET_GEOFENCE_LOCATIONS,
  GET_GEOFENCE_LOCATIONS_SUCCESS,
  GET_GEOFENCE_LOCATIONS_FAILURE,
  DELETE_GEOFENCE_LOCATION,
  DELETE_GEOFENCE_LOCATION_SUCCESS,
  DELETE_GEOFENCE_LOCATION_FAILURE,
  ADD_GEOFENCE_LOCATION,
  ADD_GEOFENCE_LOCATION_SUCCESS,
  ADD_GEOFENCE_LOCATION_FAILURE,
  UPDATE_GEOFENCE_LOCATION,
  UPDATE_GEOFENCE_LOCATION_SUCCESS,
  UPDATE_GEOFENCE_LOCATION_FAILURE,
} from '../../modules/constants';

//Service
import { defaultApi } from '../../utils/axiosApi';

const API_ENDPOINT = '/albait/geofence-locations/';

export function* handleGetGeofenceLocations({ payload }) {
  try {
    let url = API_ENDPOINT;
    const params = [];

    // Add query parameters if payload contains filters
    if (payload) {
      // Handle search parameter
      if (payload.search) {
        params.push(`name=${encodeURIComponent(payload.search)}`);
      }

      // Handle type parameter
      if (payload.type) {
        params.push(`type=${encodeURIComponent(payload.type)}`);
      }
    }

    // Append parameters to URL if any exist
    if (params.length > 0) {
      url += '?' + params.join('&');
    }

    console.log('API Request URL:', url); // For debugging

    const response = yield defaultApi(url, 'GET');
    yield put({
      type: GET_GEOFENCE_LOCATIONS_SUCCESS,
      payload: { data: response },
    });
  } catch (err) {
    console.error('Error fetching geofence locations:', err);
    yield put({
      type: GET_GEOFENCE_LOCATIONS_FAILURE,
      payload: err,
    });
  }
}

export function* handleDeleteGeofenceLocation({ payload }) {
  try {
    const url = `${API_ENDPOINT}${payload}/`;
    const method = 'DELETE';
    const response = yield defaultApi(url, method);
    yield put({
      type: DELETE_GEOFENCE_LOCATION_SUCCESS,
      payload: { data: response, locationId: payload, notify: 'DELETE' },
    });
  } catch (err) {
    yield put({
      type: DELETE_GEOFENCE_LOCATION_FAILURE,
      payload: err,
    });
  }
}

export function* handleAddGeofenceLocation({ payload }) {
  try {
    const { ...details } = payload;
    const url = API_ENDPOINT;
    const method = 'POST';
    const response = yield defaultApi(url, method, details);

    yield put({
      type: ADD_GEOFENCE_LOCATION_SUCCESS,
      payload: { data: response, notify: 'POST' },
    });
  } catch (err) {
    yield put({
      type: ADD_GEOFENCE_LOCATION_FAILURE,
      payload: err,
    });
  }
}

export function* handleUpdateGeofenceLocation({ payload }) {
  try {
    const { ...details } = payload;
    // remove any fields if that is null
    const filteredDetails = Object.fromEntries(
      Object.entries(details).filter(([_, value]) => value !== null)
    );
    const url = `${API_ENDPOINT}${payload.id}/`;
    const method = 'PATCH';
    const response = yield defaultApi(url, method, filteredDetails);
    yield put({
      type: UPDATE_GEOFENCE_LOCATION_SUCCESS,
      payload: { data: response, notify: 'UPDATE' },
    });
  } catch (err) {
    yield put({
      type: UPDATE_GEOFENCE_LOCATION_FAILURE,
      payload: err,
    });
  }
}

export default function* root() {
  yield all([
    // Get geofence locations list
    takeLatest(GET_GEOFENCE_LOCATIONS, handleGetGeofenceLocations),
    // Delete geofence location
    takeLatest(DELETE_GEOFENCE_LOCATION, handleDeleteGeofenceLocation),
    // Add geofence location
    takeLatest(ADD_GEOFENCE_LOCATION, handleAddGeofenceLocation),
    // Update geofence location
    takeLatest(UPDATE_GEOFENCE_LOCATION, handleUpdateGeofenceLocation),
  ]);
}